
export const changePricebreak = (state, action_data) => {
  const { idx, board_qty, data } = action_data;

  const {
    type,
    ...pr_data
  } = data

  if (type === 'multiple') return;

  const {
    qty,
    extra_parts,
    pricebreak,
  } = pr_data

  state.bom_line_items[idx].selected_part.extra_parts[board_qty] = extra_parts
  state.bom_line_items[idx].extra_parts[board_qty] = extra_parts
  state.bom_line_items[idx].qty_to_buy[board_qty] = qty
  state.bom_line_items[idx].price_by_qty[board_qty] = (pricebreak.price * qty)
  state.bom_line_items[idx].selected_part.selected_part_supplier[board_qty].selected_pricebreak[board_qty] = _.cloneDeep(pricebreak)
}